const RECENT_MUNICIPALITIES_KEY = "recentMunicipalities";
const MAX_RECENT_ITEMS = 3;

export const getRecentMunicipalities = () => {
  try {
    const stored = localStorage.getItem(RECENT_MUNICIPALITIES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error("Error reading recent municipalities:", error);
    return [];
  }
};

export const addRecentMunicipality = (municipality) => {
  try {
    const recent = getRecentMunicipalities();

    const filtered = recent.filter((item) => item.value !== municipality.value);

    // Add to beginning of array
    filtered.unshift(municipality);

    // Keep only the most recent items
    const updated = filtered.slice(0, MAX_RECENT_ITEMS);

    localStorage.setItem(RECENT_MUNICIPALITIES_KEY, JSON.stringify(updated));
    return updated;
  } catch (error) {
    console.error("Error saving recent municipality:", error);
    return [];
  }
};
